"use client";
// Imports
import { Container } from "@/components";
import { formatShowDateTimeLabel } from "@/lib/showDates";

// NewsPublishInfo
export function NewsPublishInfo({ data, display }) {
  // Render
  return display == "grid" ? gridDisplay(data) : pageDisplay(data);
}

function formatDate(date) {
  return formatShowDateTimeLabel(date);
}

function gridDisplay(data) {
  return (
    <div className="">
      <p className="text-sm">{formatDate(data?.date)}</p>
    </div>
  );
}

function pageDisplay(data) {
  return (
    <Container>
      <div
        className="py-2 my-2 border-t border-b lg:my-5 animate-section-in"
        style={{ "--anim-delay": "250ms" }}
      >
        <p className="">
          Published on <strong>{formatDate(data?.date)}</strong> by{" "}
          <strong>{data?.author?.name}</strong>
        </p>
      </div>
    </Container>
  );
}
